module.exports = __webpack_public_path__ + "static/media/NvizionSolutions-Logo-small.a2fbc371.png";